import moment from "moment"

import { getFullImagePath } from "~utils/utils"
import { createDropdownValue } from "~utils/dropdown"

import { MessageShape } from "~shapes/message"

export const step1PrefillValues = (message: MessageShape) => {
  let prefill = {
    name: message.name,
    code: message.code,
    description: message.description,
    publishedAt: moment(
      new Date(message.publishedAt || message.createdAt)
    ).toDate(),
  }

  if (message.company?.id) {
    prefill["company"] = createDropdownValue(
      message.company.name,
      message.company.id
    )
  }

  return prefill
}

export const step2PrefillValues = (message: MessageShape) => ({
  cover: message.cover ? getFullImagePath(message.cover) : null,
})
